import React from "react";
import { baseClasses, variantClasses, sizeClasses } from "./constants";
import Spinner from "@surgia/ui/atoms/spinner";
import { ButtonVariant, ButtonSize, ButtonRounded } from "./constants";
export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  startIcon?: string;
  endIcon?: string;
  rounded?: ButtonRounded;
}

const Button: React.FC<ButtonProps> = ({
  variant = "primary",
  size = "md",
  loading = false,
  disabled = false,
  children,
  className = "",
  onClick,
  startIcon,
  endIcon,
  rounded = "lg",
  ...props
}) => {
  // Disabled state classes
  const disabledClasses =
    disabled || loading ? "opacity-50 cursor-not-allowed" : "";

  // Combine all classes
  const classes = [
    baseClasses,
    variantClasses[variant],
    sizeClasses[size],
    disabledClasses,
    className,
  ].join(" ");

  // Handle click event
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!disabled && !loading && onClick) {
      onClick(event);
    }
  };

  return (
    <button
      className={classes}
      disabled={disabled || loading}
      onClick={handleClick}
      type={props.type || "button"} // Default to 'button' if not specified
      {...props}
    >
      {loading ? (
        <Spinner />
      ) : startIcon ? (
        <img src={startIcon} alt="Start Icon" className="mr-2" />
      ) : null}
      {children}
      {endIcon ? <img src={endIcon} alt="End Icon" className="ml-2" /> : null}
    </button>
  );
};

export default Button;
